import { render, staticRenderFns } from "./GenerateLink.vue?vue&type=template&id=51a70e6b&scoped=true"
import script from "./GenerateLink.vue?vue&type=script&lang=js"
export * from "./GenerateLink.vue?vue&type=script&lang=js"
import style0 from "./GenerateLink.vue?vue&type=style&index=0&id=51a70e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a70e6b",
  null
  
)

export default component.exports